import PrivacyPolicy from "../components/common/PrivacyPolicy";
import TermsAndConditions from "../components/common/TermsAndConditions";

import { Modal } from "../components/ui/modal";
import { useModal } from "../hooks/useModal";


const AppFooter: React.FC = () => {
  const { isOpen: isPrivacyOpen, openModal: openPrivacy, closeModal: closePrivacy } = useModal();
  const { isOpen: isTermsOpen, openModal: openTerms, closeModal: closeTerms } = useModal();

  return (
    <footer className="relative md:sticky bottom-0 z-9999 flex w-full bg-white border-t border-gray-200 dark:border-gray-800 dark:bg-gray-900">
      <div className="flex flex-col items-center justify-between grow lg:flex-row lg:px-6">  
        <div className="hidden md:flex items-center sm:w-auto lg:w-full sm:justify-center lg:justify-start gap-2 px-3 py-4 sm:gap-4 lg:px-0">      
          <div className="flex text-sm text-gray-500 dark:text-gray-400">
            Continuously improving. Latest release: October 27, 2026
          </div>
        </div>  
        <div className="flex items-center sm:w-auto lg:w-full sm:justify-center lg:justify-end gap-2 px-3 py-4 sm:gap-4 lg:px-0">
          <div
            className="flex text-sm text-gray-500 dark:text-gray-400 cursor-pointer"
            onClick={openTerms} 
          > 
            Terms and Conditions
          </div>
          <div
            className="flex text-sm text-gray-500 dark:text-gray-400"
            onClick={openPrivacy} 
          > 
            and 
          </div>
          <div
            className="flex text-sm text-gray-500 dark:text-gray-400 cursor-pointer"
            onClick={openPrivacy} 
          > 
            Privacy Policy
          </div>
        </div>
      </div>
      <Modal
        isOpen={isPrivacyOpen}
        onClose={closePrivacy}
        showCloseButton
        className="max-w-[800px] max-h-[95vh] overflow-x-auto custom-scrollbar">
          <PrivacyPolicy />
      </Modal>
      <Modal
        isOpen={isTermsOpen}
        onClose={closeTerms}
        showCloseButton
        className="max-w-[800px] max-h-[95vh] overflow-x-auto custom-scrollbar">
          <TermsAndConditions />
      </Modal>
    </footer>
  );
};

export default AppFooter;
